import { useMemo } from 'react'

import { IContinuousRoute } from '$/types'
import { useGetActiveSystemScopeFilterProfileQuery } from 'app/services/api/filterprofiles'

const useSystemScopeRoutesEffect = () => {
  const { systemScopeFilterProfile } =
    useGetActiveSystemScopeFilterProfileQuery()

  return useMemo(() => {
    let queryString = ''
    let routeIds = ''

    if (systemScopeFilterProfile?.continuousRoutes?.length) {
      systemScopeFilterProfile.continuousRoutes.forEach(
        (route: IContinuousRoute) => {
          routeIds += `'${route.id}',`
        }
      )
      routeIds = routeIds.slice(0, -1)
      queryString = `RouteId IN (${routeIds})`
    }

    return queryString
  }, [systemScopeFilterProfile?.continuousRoutes])
}

export default useSystemScopeRoutesEffect
